import { Theme } from '@material-ui/core/styles';

export const getMuiListItem = (theme: Theme): Record<string, unknown> => ({
  MuiListItem: {
    root: {
      '&.Mui-selected': {
        backgroundColor: theme.palette.common.white,
      },
    },

    container: {
      '& > .MuiListItemSecondaryAction-root': {
        right: '8px',
      },

      [theme.breakpoints.up('md')]: {
        '& > .MuiListItemSecondaryAction-root': {
          right: 0,
        },
      },
    },
  },
});
